const RPAHook_AfterImport = ({results, model}) => {
    return (dispatch, getState, {rcsdk, rcRPA}) => {
        return rcRPA.hookOnImport({model, results})

    }
}
export {RPAHook_AfterImport};